import { SelectOptions } from '@spo/logic';
import { ActionMeta, MultiValue as mv } from 'react-select';
import { metaActions } from '../../../utils/metaActions';

export const sortOptions = (
  selectedOptions: SelectOptions[] | mv<SelectOptions>,
  allOptions: SelectOptions[] | mv<SelectOptions>,
) => {
  const sortedSelectedOptions = [...(selectedOptions || [])].sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  const sortedAllOptions = [...allOptions].sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  const sortedConsolidatedList = [
    ...sortedSelectedOptions,
    ...sortedAllOptions,
  ];

  return [...new Set(sortedConsolidatedList)];
};

export const concatOptions = (
  actionMeta: ActionMeta<SelectOptions>,
  selectedOptions: mv<SelectOptions> | null,
  options: mv<SelectOptions>,
) => {
  let allSelectedProductNatures: SelectOptions[];

  switch (actionMeta.action) {
    case metaActions.selectOption:
      allSelectedProductNatures = [
        ...new Set([...(selectedOptions ?? []), ...options]),
      ];
      break;
    case metaActions.deselectOption:
      allSelectedProductNatures = [
        ...new Set(
          selectedOptions?.filter(
            (productNature) => productNature.value !== actionMeta.option?.value,
          ),
        ),
      ];
      break;
    case metaActions.removeValue:
    case metaActions.popValue:
      allSelectedProductNatures = [
        ...new Set(
          selectedOptions?.filter(
            (productNature) =>
              productNature.value !== actionMeta.removedValue?.value,
          ),
        ),
      ];
      break;
    default:
      allSelectedProductNatures = [];
      break;
  }

  return allSelectedProductNatures;
};
